<template>
  <section>
    <report-filter-bar
      v-model="filter"
      :preset="preset"
      :busy="isAnyLoading"
      :compare-label="compareLabel"
      :show-interval="false"
      @preset="applyPreset"
      @change="refresh"
      @refresh="refresh"
    />

    <b-row class="match-height">
      <b-col
        lg="7"
        cols="12"
        class="mb-1"
      >
        <report-table
          :breakdown="top"
          title="پرفروش‌ترین محصول‌ها"
          :subtitle="rangeLabel"
          label-title="محصول"
          show-image
          :loading="loading('top')"
          :route-for="productRoute"
        />
      </b-col>

      <b-col
        lg="5"
        cols="12"
        class="mb-1"
      >
        <report-table
          :breakdown="byCategory"
          title="سهم دسته‌بندی‌ها"
          subtitle="فقط دسته‌ی اصلی هر محصول شمرده می‌شود"
          label-title="دسته"
          :loading="loading('byCategory')"
        />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col
        lg="5"
        cols="12"
        class="mb-1"
      >
        <report-table
          :breakdown="byBrand"
          title="سهم برندها"
          :subtitle="rangeLabel"
          label-title="برند"
          :loading="loading('byBrand')"
        />
      </b-col>

      <b-col
        lg="7"
        cols="12"
        class="mb-1"
      >
        <report-table
          :breakdown="conversion"
          title="نرخ تبدیل بازدید به فروش"
          subtitle="بازدیدکننده‌ی یکتا بر اساس شناسه‌ی مرورگر شمرده می‌شود"
          label-title="محصول"
          show-image
          :show-share="false"
          :loading="loading('conversion')"
          :route-for="productRoute"
        />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col
        lg="6"
        cols="12"
        class="mb-1"
      >
        <report-table
          :breakdown="slowMovers"
          title="کالاهای کم‌گردش"
          subtitle="بازدید قابل توجه دارند ولی در این بازه فروش نداشته‌اند — بیشترین پتانسیل بهبود"
          label-title="محصول"
          show-image
          :show-share="false"
          :loading="loading('slowMovers')"
          :route-for="productRoute"
          empty-text="کالای کم‌گردشی پیدا نشد"
        />
      </b-col>

      <b-col
        lg="6"
        cols="12"
        class="mb-1"
      >
        <report-table
          :breakdown="stock"
          title="هشدار موجودی"
          subtitle="کالاهای «موجود» با موجودی ۵ یا کمتر — مستقل از بازه‌ی انتخابی"
          label-title="محصول"
          show-image
          :show-share="false"
          :loading="loading('stock')"
          :route-for="productRoute"
          empty-text="موجودی همه‌ی کالاها سالم است"
        />
      </b-col>
    </b-row>
  </section>
</template>

<script>
import reportMixin from '@core/mixins/report'

export default {
  name: 'ReportProducts',
  mixins: [reportMixin],
  data() {
    return {
      top: null,
      byCategory: null,
      byBrand: null,
      conversion: null,
      slowMovers: null,
      stock: null,
    }
  },
  computed: {
    compareLabel() {
      return this.top && this.top.CompareRange ? this.top.CompareRange.Label : null
    },
  },
  created() {
    this.refresh()
  },
  methods: {
    refresh() {
      const api = this.$api.report

      this.fetchReport('top', api.productTop)
      this.fetchReport('byCategory', api.productByCategory)
      this.fetchReport('byBrand', api.productByBrand)
      this.fetchReport('conversion', api.productConversion)
      this.fetchReport('slowMovers', api.productSlowMovers)
      this.fetchReport('stock', api.productStock)
    },

    productRoute(row) {
      return row.Id ? { name: 'updateproduct', params: { id: row.Id } } : null
    },
  },
}
</script>
